import axios from 'axios';

export const CACHE_TTL_MS = 1000 * 60 * 10; // 10 mins

// Idea taken from https://alligator.io/react/axios-react/
const API = axios.create({
  baseURL: import.meta.env.VITE_BACKEND_API_URL,
  headers: {
    'x-omalumme-version': 'web',
  },
});

export default API;
